// extracted by mini-css-extract-plugin
module.exports = {"label":"inputBlock_label__2nQU7","text":"inputBlock_text__B1xpO","required":"inputBlock_required__ZBPcd"};
    if(module.hot) {
      // 1783591931042
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  